// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { getDashboardData, getCampaignDetails, getNsuCashbackDetails } from "./_request";
import { useEffect, useState } from "react";
import pointBrand from "../../assets/images/icons/catering-icons/ic-my-points.svg";
import MDButton from "components/MDButton";

import pointsIcon from "../../assets/images/icons/catering-icons/points.svg";
import dollarBag from "../../assets/images/icons/catering-icons/whiteDollarBag.svg";

import UpdatePasswordModal from "../../examples/Modal/UpdatePassWordModal";
import { resendOtp, updateCustomerPassword, verifyTokenApi } from "../authentication/_request";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";

import { useAuth } from "context";
import data from "./components/Projects/data";
import EmailCustomModal from "examples/Modal/EmailConfirmationModal";
import { getGtmCode } from "core/AuthHelper";
import { getRedeemPoints } from "layouts/mypoint/_request";
import { generateGiftCard } from "layouts/mypoint/_request";
import { useNavigate, useLocation } from "react-router-dom";
import { CONVERSION_POINTS } from "../../core/constant";
import formatNumberWithCommas from "../../core/utils/formatNumberWithCommas";
import { NavbarAlert } from "examples/Alert";
import config from "../../config/config";
import { getCustomerAPI } from "layouts/profile/_request";
import OtpConfirmationModal from "examples/Modal/OtpConfirmationModal";
import { usePhoneVerification } from "hooks/usePhoneVerification";
import TagManager from "react-gtm-module";
import { setGtmCode } from "../../core/AuthHelper";
import OrderNowBanner from "./components/OrdersOverview/OrderNowBanner";
const notificationEmail =
  config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].NOTIFICATION_EMAIL;

function Dashboard() {
  const {
    verifiedCustomer,
    saveAuthData,
    showSnackbarWithMessage,
    miniSidenav,
  } = useAuth();

  const {
    showOtpModal,
    verificationIdentifier,
    verificationType,
    handleOtpVerify,
    handleSendOTP,
    handleDismissOtpModal,
    holdPhoneVerification,
    resumePhoneVerification,
    checkPhoneVerification,
  } = usePhoneVerification();

  const [dashboardLoader, setDashboardLoader] = useState(true);
  const [recentOrderData, setRecentOrderData] = useState([]);
  const [topRestaurantData, setTopRestaurantData] = useState([]);
  const [availablePoints, setAvailablePoints] = useState(0);
  const [totalPointsEarned, setTotalPointsEarned] = useState(0);
  const [totalRedeemedPoints, setTotalReedemedPonts] = useState(0);
  const [mostRewardingRestaurant, setMostRewardingRestaurant] = useState();
  const [fullCustomer, setFullCustomer] = useState(null);
  const [forgotPassword, setForgotPassword] = useState(false);

  //DefaultPassword Logic
  const [spinner, setSpinner] = useState(false);
  const [userPassword, setUserPassword] = useState("");
  const [passwordModalComplete, setPasswordModalComplete] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [campaign, setCampaign] = useState("");
  const [restaurantDetails, setRestaurantDetails] = useState("");
  const [isCampaignAvailable, setIsCampaignAvailable] = useState(false);
  const [nsuCashbackData, setNsuCashbackData] = useState();
  const [openUpdatePasswordModal, setOpenUpdatePasswordModal] = useState(false);
  const [campaignExpiry, setCampaignExpiry] = useState("");

  const { darkMode } = useAuth();

  const [loader, setLoader] = useState(false);
  const [minRedeemPoints, setMinRedeemPoints] = useState(0);
  const [openRedeemModal, setopenRedeemModal] = useState(false);
  const [redeemPoints, setRedeemPoints] = useState(0);
  const [redeemAmount, setRedeemAmount] = useState(0);
  const [isPendingRedeemptionRequestAmount, setIsPendingRedeemRequestAmount] = useState();
  const [userEmail, setUserEmail] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState("");
  const [status, setStatus] = useState({
    isOTPVisible: false,
  });
  const [otp, setOtp] = useState("");
  const [gtmInitialized, setGtmInitialized] = useState(false);

  const handleClose = () => {
    setOpenUpdatePasswordModal(false);
    // Mark password modal as complete even if user dismisses it
    setPasswordModalComplete(true);
    // Resume phone verification after a brief delay
    setTimeout(() => {
      resumePhoneVerification();
    }, 200);
  };

  const updatePassWord = async (newPassword) => {
    try {
      setModalLoader(true);
      setSpinner(true);
      const updatePasswordResponse = await updateCustomerPassword({
        newPassword,
        userPassword,
        forgotPassword,
      });
      const { success, data, message } = updatePasswordResponse.data;
      if (success) {
        const authData = data.tokens;
        await saveAuthData(authData);
        const verifyResponse = await verifyTokenApi({ accessToken: authData.accessToken });
        const { success: verifySuccess, data: verifyData } = verifyResponse.data;
        if (verifySuccess && !verifyData.verifiedData.defaultPassword) {
          showSnackbarWithMessage({
            type: "success",
            message: message,
          });
          setPasswordModalComplete(true);
          setOpenUpdatePasswordModal(false);
          setTimeout(() => {
            resumePhoneVerification();
          }, 300);
        }
      } else {
        showSnackbarWithMessage({
          type: "error",
          message: message,
        });
        setModalLoader(false);
        setSpinner(false);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setModalLoader(false);
      setSpinner(false);
    }
  };

  useEffect(() => {
    if (location.state?.forgotPassword) {
      setForgotPassword(true);

      navigate(location.pathname, { replace: true });
    }
  }, [location.state, navigate]);

  useEffect(() => {
    if (
      (!verifiedCustomer?.simulateUser && verifiedCustomer.defaultPassword) ||
      forgotPassword
    ) {
      // If password needs to be set, hold off on phone verification
      holdPhoneVerification();
      setOpenUpdatePasswordModal(true);
    } else {
      // If no password needs to be set, allow phone verification to proceed normally
      setPasswordModalComplete(true);
    }
  }, [verifiedCustomer, holdPhoneVerification, forgotPassword]);

  //DefaultPassword Logic END

  const dashboardData = async () => {
    try {
      const {
        data: { success, data },
      } = await getDashboardData();
      if (success && data) {
        setRecentOrderData(data.recentOrders);
        setAvailablePoints(data.availableToRedeem);
        setTotalReedemedPonts(data.pointRedeemed);
        setTotalPointsEarned(data.pointEarned);
        setMostRewardingRestaurant(data.maxCashbackEarnedRestaurant);
        setTopRestaurantData(data.customerOrderSummary);
        setDashboardLoader(false);
      } else {
        setDashboardLoader(false);
      }
    } catch (e) {
      setDashboardLoader(false);
      console.log(e);
    }
  };
  const campaignData = async () => {
    try {
      const {
        data: { success, data },
      } = await getCampaignDetails(true);
      if (success && data) {
        setIsCampaignAvailable(data.isCampaign);
        setCampaign(data.campaign);
        setCampaignExpiry(data.campaignExpiry);
        setRestaurantDetails(data);
        setDashboardLoader(false);
      } else {
        setDashboardLoader(false);
      }
    } catch (e) {
      setDashboardLoader(false);
      console.log(e);
    }
  };
  const getCustomerData = async () => {
    try {
      const {
        data: { success, data },
      } = await getCustomerAPI();
      if (success) {
        setFullCustomer(data?.customer?.customer_restaurant_stores_infos?.[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const nsuCashbackDataDetails = async () => {
    try {
      const {
        data: { success, data },
      } = await getNsuCashbackDetails();
      if (success) {
        setNsuCashbackData(data.nsuCashbackData);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    dashboardData();
    getCustomerData();
    campaignData();
    nsuCashbackDataDetails();
  }, []);

  useEffect(() => {
    if (
      (!verifiedCustomer?.simulateUser && verifiedCustomer.defaultPassword) ||
      forgotPassword
    ) {
      setOpenUpdatePasswordModal(true);
    }
  }, [verifiedCustomer, forgotPassword]);

  const handleRedeemClose = () => {
    setopenRedeemModal(!openRedeemModal);
    setStatus({
      isOTPVisible: false,
    });
    setOtp("");
  };

  const getRedeemPointsData = async () => {
    try {
      const {
        data: { success, data },
      } = await getRedeemPoints();
      if (success) {
        if (data.customerPoints) {
          setIsPendingRedeemRequestAmount(data.redemption_request_points);
          setRedeemPoints(data.customerPoints);
          setRedeemAmount(data.customerPoints / 100);
          setMinRedeemPoints(data.minimum_points);
        } else {
          setIsPendingRedeemRequestAmount(0);
          setRedeemPoints(0);
          setRedeemAmount(0);
          setMinRedeemPoints(data.minimum_points);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  const handleConfirm = async () => {
    try {
      if (redeemPoints < minRedeemPoints) {
        showSnackbarWithMessage({
          type: "error",
          message: `Minimum redemption points must be greter than ${minRedeemPoints}`,
        });
        return;
      }
      setLoader(true);
      if (selectedValue) {
        const {
          data: { success, message },
        } = await generateGiftCard(selectedValue);
        if (success) {
          setLoader(false);
          await getRedeemPointsData();
          showSnackbarWithMessage({
            type: "success",
            message,
          });
          handleRedeemClose();
          navigate("/my-points");
        } else {
          showSnackbarWithMessage({
            type: "error",
            message,
          });
        }
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    } finally {
      setLoader(false);
    }
  };

  const verifyTokenFunc = async () => {
    try {
      const location = useLocation();
      const searchParams = new URLSearchParams(location.search);
      const tokens = searchParams.get("landing_page_tokens");
      const gtmCode = searchParams.get("s");
      console.log(window.location.href, gtmCode);
      if (gtmCode) {
        setGtmCode(gtmCode); // Save GTM code to local storage
      }
      if (!tokens) return;
      saveAuthData(JSON.parse(decodeURIComponent(tokens)));
      const auth = JSON.parse(decodeURIComponent(tokens));
      const {
        data: { success, data },
      } = await verifyTokenApi({ accessToken: auth.accessToken });
      if (success) {
        setUserEmail(data.verifiedData.email);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    if (true) {
      getRedeemPointsData();
      verifyTokenFunc();
    }
    // Initialize GTM here after data is fetched
    const gtmCode = getGtmCode();
    const isGtmEnabled = config[process.env?.REACT_APP_ENV?.toUpperCase()]?.GTM_ENABLED;
    if (isGtmEnabled && gtmCode && !gtmInitialized) {
      TagManager.initialize({ gtmId: `GTM-${gtmCode}` });
      setGtmInitialized(true);
    }
  }, []);

  return (
    <>
      <DashboardNavbar />
      <NavbarAlert />
      <DashboardLayout>
        {config[process.env?.REACT_APP_ENV?.toUpperCase()]?.GTM_ENABLED && getGtmCode() && (
          <div
            dangerouslySetInnerHTML={{
              __html: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-${getGtmCode()}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`,
            }}
          />
        )}
        {dashboardLoader && <SimpleBackdrop />}
        <MDBox
          py={2}
          sx={{
            mt: 9,
            "@media (max-width:992px)": {
              mt: 8,
            },
          }}
        >
          {isCampaignAvailable && (
            <OrderNowBanner
              expiryDate={
                fullCustomer?.customer_restaurant_stores_info_campaigns?.[0]?.campaignExpirationDate
              }
              restaurantDetails={restaurantDetails}
              campaign={campaign}
            />
          )}

          {nsuCashbackData &&
            !!nsuCashbackData.length &&
            nsuCashbackData.map((restaurant, index) => {
              console.log(restaurant);
              return (
                <MDBox
                  key={index}
                  variant="text"
                  p={1}
                  mb={3}
                  sx={{
                    backgroundColor: darkMode ? "#3a4354" : "#d4edda",
                    display: "inline-flex",
                    borderRadius: "4px",
                  }}
                  size="large"
                  onClick={() => { }}
                >
                  <MDTypography variant="button" fontWeight="normal" sx={{ cursor: "initial" }}>
                    You can place your order with
                    <span
                      style={{ fontWeight: "bold" }}
                    >{` ${restaurant._restaurant_store_restaurant_store.name}`}</span>{" "}
                    restaurant before
                    <span
                      style={{ fontWeight: "bold" }}
                      dangerouslySetInnerHTML={{
                        __html: ` ${new Date(restaurant.pointsExpiryDate).toDateString()} `,
                      }}
                    />
                    at{" "}
                    <span
                      style={{ fontWeight: "bold" }}
                    >{`${restaurant._restaurant_store_restaurant_store.storeAddressLine1}, ${restaurant._restaurant_store_restaurant_store.city} `}</span>
                    and get extra signup cashback of{" "}
                    <span
                      style={{ fontWeight: "bold" }}
                    >{`${restaurant.cashbackPoints} points `}</span>
                    on your <span style={{ fontWeight: "bold" }}>{`first`}</span> order.
                  </MDTypography>
                </MDBox>
              );
            })}

          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="primary"
                  pointBrand={dollarBag}
                  title="Available to redeem"
                  bottomLeft={
                    <>
                      {!!isPendingRedeemptionRequestAmount && (
                        <MDTypography
                          sx={{
                            fontSize: "0.8rem",
                          }}
                        >
                          Pending request:
                          <strong> ${(isPendingRedeemptionRequestAmount / 100).toFixed(2)}</strong>
                        </MDTypography>
                      )}
                    </>
                  }
                  bottomRight={
                    <MDButton
                      variant="gradient"
                      color={"success"}
                      size="medium"
                      sx={{ textTransform: "none", height: "40px" }}
                      onClick={() => {
                        setopenRedeemModal(true);
                      }}
                      disabled={
                        redeemPoints < minRedeemPoints ||
                        availablePoints - isPendingRedeemptionRequestAmount <= 0 ||
                        isPendingRedeemptionRequestAmount
                      }
                    >
                      Redeem Now
                    </MDButton>
                  }
                  pointsData={
                    <MDBox>
                      {availablePoints
                        ? availablePoints - (isPendingRedeemptionRequestAmount || 0) + " points"
                        : 0 + " points"}
                      <MDTypography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 400,
                        }}
                        as="span"
                      >
                        {availablePoints
                          ? " (~$" +
                          formatNumberWithCommas(
                            Math.round(
                              (availablePoints - (isPendingRedeemptionRequestAmount || 0)) /
                              CONVERSION_POINTS
                            )
                          ) +
                          ")"
                          : " (~$" + 0 + ")"}
                      </MDTypography>
                    </MDBox>
                  }
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="success"
                  title="Total points earned"
                  pointBrand={pointsIcon}
                  pointsData={
                    <MDBox>
                      {(totalPointsEarned || 0) + " points"}
                      <MDTypography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 400,
                        }}
                        as="span"
                      >
                        {totalPointsEarned
                          ? " (~$" +
                          formatNumberWithCommas(
                            Math.round(totalPointsEarned / CONVERSION_POINTS)
                          ) +
                          ")"
                          : " (~$" + 0 + ")"}
                      </MDTypography>
                    </MDBox>
                  }
                  bottomRight={" "}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={1.5}>
                <ComplexStatisticsCard
                  color="info"
                  title="Total points redeemed"
                  pointBrand={pointBrand}
                  pointsData={
                    <MDBox>
                      {(totalRedeemedPoints ? Math.abs(totalRedeemedPoints) : 0) + " points"}
                      <MDTypography
                        sx={{
                          fontSize: "0.8rem",
                          fontWeight: 400,
                        }}
                        as="span"
                      >
                        {totalRedeemedPoints
                          ? " (~$" +
                          formatNumberWithCommas(
                            Math.round(Math.abs(totalRedeemedPoints) / CONVERSION_POINTS)
                          ) +
                          ")"
                          : " (~$" + 0 + ")"}
                      </MDTypography>
                    </MDBox>
                  }
                  bottomRight={" "}
                />
              </MDBox>
            </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                title="Most rewarding restaurant"
                pointBrand={restaurantIcon}
                pointsData={`${
                  mostRewardingRestaurant?.name ? mostRewardingRestaurant?.name : ""
                }(${
                  mostRewardingRestaurant?.maxCashback ? mostRewardingRestaurant?.maxCashback : 0
                } points)`}
                bottomRight={" "}
              />
            </MDBox>
          </Grid> */}
          </Grid>

          <MDBox mt={2}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={8}>
                <Projects topRestaurantData={topRestaurantData} />
              </Grid>
              <Grid item xs={12} md={6} lg={4}>
                {!miniSidenav && <OrdersOverview recentOrderData={recentOrderData} />}
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <UpdatePasswordModal
          open={openUpdatePasswordModal}
          onConfirm={updatePassWord}
          loader={modalLoader}
          userEmail={verifiedCustomer?.email}
          userPassword={userPassword}
          handleClose={handleClose}
          setLoader={setModalLoader}
          title="Set Password"
          setUserPassword={setUserPassword}
          spinner={spinner}
          removeOnClose={true}
          forgotPassword={forgotPassword}
        />
        <EmailCustomModal
          open={openRedeemModal}
          handleClose={handleRedeemClose}
          color={"success"}
          title={`You are about to redeem ${redeemPoints - (isPendingRedeemptionRequestAmount || 0)
            } points equivalent to $${redeemAmount -
            (isPendingRedeemptionRequestAmount ? isPendingRedeemptionRequestAmount / 100 : 0)
            } `}
          subtitle={
            "We will send you an Amazon.com gift card of the same value within the next 24-48 hours to the selected email address."
          }
          subtitle2={
            <>
              We recommend to use your <strong>personal email</strong>. If you use a work email,
              your organization policies may block it for spam or it may be quarantined.
              Additionally, the email&apos;s contents may be visible to your system admin which
              could compromise your claim code.
            </>
          }
          userEmail={userEmail}
          description={
            status.isOTPVisible ? (
              <p>
                Please check your inbox and spam for emails from:
                <p>{notificationEmail}</p>
              </p>
            ) : (
              ""
            )
          }
          onConfirm={handleConfirm}
          loader={loader}
          isIcon={true}
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          setStatus={setStatus}
          status={status}
          setOtp={setOtp}
          otp={otp}
        />
        {showOtpModal && (
          <OtpConfirmationModal
            identifier={verificationIdentifier}
            type={verificationType}
            open={showOtpModal}
            onClose={handleDismissOtpModal}
            onVerify={handleOtpVerify}
            onSendOTP={handleSendOTP}
          />
        )}
      </DashboardLayout>
    </>
  );
}

export default Dashboard;
